import { define } from '../../define.js';
import { LuxenStoriesViewer } from './stories-viewer.js';
export * from './stories-viewer.js';
define('stories-viewer', LuxenStoriesViewer);
